import api from "./api";

const route = "/montos";

export default {
  getMontosProyecto: (idProyecto) => api.get(`${route}/${idProyecto}`),
  getMontosContrato: (idProyecto, idContrato) =>
    api.get(`${route}/${idProyecto}/${idContrato}`),
};
